import SvgIcon from "@mui/material/SvgIcon";

export default function Logo() {
  return (
    <SvgIcon
      aria-label="Phonebook logo"
      viewBox="0 0 110 128"
      sx={{
        marginRight: "10px",
        transitionProperty: ["color", "transform"],
        transitionDuration: "300ms",
        transitionTimingFunction: "ease-in-out",
        "&:hover, &:focus": { transform: "scale(1.3)" },
      }}
    >
      <path
        d="M104.3,14.7c-2.1,0-3.7,1.7-3.7,3.7c0,0,0,0,0,0l0,93c0,3.9-3.2,7.1-7.1,7.1H16.2c-3.7,0-6.8-3-6.8-6.8
	c0-0.3,0-0.6,0.1-0.9c0.5-3.4,3.5-5.9,6.9-5.9h68.9c5.2,0,9.5-4.2,9.5-9.5l0-86.3c0-4-3.2-7.2-7.2-7.2c0,0,0,0,0,0H9.5
	c-4,0-7.2,3.2-7.2,7.2v99.9c-0.3,1.8-0.3,3.6,0,5.4c1.3,6.7,7.1,11.5,13.9,11.5h77.4c7.3,0,13.4-5.4,14.4-12.6
	c0.1-0.6,0.1-1.3,0.1-1.9v-93C108,16.4,106.3,14.7,104.3,14.7z M21.3,30.6l4.5-5.6c1.6-2.2,4.6-2.6,6.8-1c0.2,0.2,0.4,0.4,0.6,0.6
	c0.2,0.2,6.7,9,6.9,9.2c0.9,1.6,0.7,3.7-0.4,5.2l-2.9,3.7c-0.4,0.5-0.5,1.2-0.2,1.8c0.4,0.8,0.8,1.6,1.2,2.5
	c2.1,3.8,4.7,7.3,7.8,10.4c2.7,2.7,5.8,5,9.2,6.7c0.8,0.4,1.6,0.8,2.5,1.2c0.6,0.3,1.3,0.2,1.8-0.2l3.7-2.9c1.5-1.1,3.5-1.3,5.1-0.4
	c0.2,0.1,9,6.7,9.2,6.9c1.9,1.8,2,4.9,0.2,6.9c-0.2,0.2-0.4,0.4-0.6,0.6l-5.6,4.6c-10,8.4-22.2-1.7-29.6-8.6c-1-0.9-3.4-3.3-5.9-5.8
	c-2.4-2.4-4.8-4.9-5.7-5.9C23,52.8,13,40.6,21.3,30.6z"
      />
    </SvgIcon>
  );
}
